<template>
    <span>
        <button :disabled="true" v-show="!showPlay && !showPause && !showDownload && !showLoader">
            <svg-item :size="20" :icon="'play'" :color="'--disabled-color'" ></svg-item>
        </button>
        <button @click="onDownloadAudio()"  v-show="showDownload">
            <svg-item :size="20" :icon="'download'" :color="'--disabled-color'" ></svg-item>
        </button>
        <button v-show="showLoader">
            <loader :size="24" :flag="true" :customAttribute="{tag: 'circle', children: 0, attribute:'stroke', value: '--main-color'}" ></loader>
        </button>
        <button @click="onPlayAudio()" v-show="showPlay">
            <svg-item :size="20" :icon="'play'" :color="'--main-color'" ></svg-item>
        </button>
        <button @click="onPlayAudio()" v-show="showPause">
            <svg-item :size="20" :icon="'pause'" :color="'--main-color'" ></svg-item>
        </button>
    </span>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    props: {
        audio: {
            type: Object,
            default: null
        },
        /** Modo cola (TTS + audios no leídos): prioriza sobre reproducción de un solo audio */
        useUnreadQueue: {
            type: Boolean,
            default: false
        },
        canPlayUnread: {
            type: Boolean,
            default: false
        },
        unreadPlaybackActive: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {};
    },
    computed: {
        queueMode () {
            return this.useUnreadQueue;
        },
        showPlay () {
            if (this.queueMode) {
                return this.canPlayUnread && !this.unreadPlaybackActive;
            }
            return this.audio && this.audio.exists && !this.audio.playing;
        },
        showPause () {
            if (this.queueMode) {
                return this.canPlayUnread && this.unreadPlaybackActive;
            }
            return this.audio && this.audio.exists && this.audio.playing;
        },
        showDownload () {
            if (this.queueMode) {
                return false;
            }
            return this.audio && this.audio.corrupted;
        },
        showLoader () {
            if (this.queueMode) {
                return false;
            }
            return this.audio && this.audio.downloadInProgress;
        }
    },
    mounted () {
    },
    methods: {
        ...mapActions({
            pauseAll: 'messages/pauseAll',
            playUnreadMessages: 'messages/playUnreadMessages'
        }),
        onPlayAudio () {
            if (this.queueMode) {
                this.playUnreadMessages();
                return;
            }
            if (!this.audio) {
                return;
            }
            if (!this.audio.playing) {
                this.pauseAll();
                this.audio.play();
            } else {
                this.audio.pause();
            }
        },

        onDownloadAudio () {
            if (this.audio) {
                this.audio.download();
            }
        }
    }
};
</script>
<style  scoped>
button {
    background: transparent;
    border: 0;
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/AudioButtons.vue